
import { Options, Vue } from 'vue-class-component'
import { parseBackendErrors } from '@/composables/utils'
import BalanceService, { EditEarningParams } from '@/services/BalanceService'

@Options({
  props: {
    historyId: { type: Number, required: true },
    amount: { type: Number, default: 0 },
  },
  emits: ['success', 'error']
})
export default class EditBalanceForm extends Vue {
  historyId!: number
  amount!: number
  promotion = ''
  
  localAmount = 0

  errorMessages: string[] = []
  isFormLoading = false
  isFormValid = false

  created() {
    this.initializeData()
  }

  initializeData() {
    this.localAmount = this.amount
    this.validateForm()
  }

  validateForm() {
    this.isFormValid = Boolean(
      this.promotion && 
      this.localAmount && 
      this.localAmount > 0
    )
  }

  async submit() {
    if (!this.isFormValid || this.isFormLoading) return

    this.errorMessages = []
    this.isFormLoading = true
    try {
      await BalanceService.editEarningAmount(this.preparePayload())
      this.$emit('success')
    } catch (error: any) {
      this.errorMessages = parseBackendErrors(error)
      this.$emit('error', error)
    } finally {
      this.isFormLoading = false
    }
  }

  preparePayload(): EditEarningParams {
    return {
      earning_id: this.historyId,
      amount: this.localAmount,
      promotion: this.promotion,
    }
  }

}
